exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question-row[data-v-8d8ad320]{position:relative;margin-bottom:20px;padding:15px;background-color:#fff;border:1px solid #ddd;border-radius:5px}.input-question[data-v-8d8ad320]{margin-bottom:10px}#btn-remove-question[data-v-8d8ad320]{position:absolute;top:15px;right:15px}.answers-container[data-v-8d8ad320]{padding:15px;background-color:#f2f2f2}.answers-container .row[data-v-8d8ad320]{width:100%}.answer-content[data-v-8d8ad320]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:10px}h4[data-v-8d8ad320]{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8d8ad320","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/app/components/questionRow.vue
// module id = cTDB
// module chunks = 0